var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('router-view')],1),_c('applicationFooter'),_c('div',{attrs:{"id":"progress-container"}},[_c('div',{attrs:{"id":"progress-item"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }